import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
export interface S3UploadResponse {
  fileName: string;
  signedUrl: string;
  fileNameWithAttachId: string;
  attachId: number;
}
type S3UploadRequest = string[];
const useInvoiceS3UploadApi = () => {
  const call = useCallback(
    (body: S3UploadRequest = []) =>
      axiosInstance
        .post<S3UploadResponse[]>(api.getInvoiceUploadS3UrlFn(), body)
        .then((response) => response.data)
        .catch((error) => {
          throw error;
        }),
    []
  );
  const { execute, isLoading } = useAsync(call, false);
  return {
    S3Files: execute,
    isS3InvoiceFileUploading: isLoading,
  };
};
export default useInvoiceS3UploadApi;
